/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    User,
    UserFromJSON,
    UserToJSON,
    UserMeAllOf,
    UserMeAllOfFromJSON,
    UserMeAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserMe
 */
export interface UserMe {
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    isMod?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserMe
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    pic?: string;
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    picUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    isExternal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    emailNotify: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    iosPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    androidPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    browserPush: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMe
     */
    hasPassword: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMe
     */
    intercomIdentity?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserMe
     */
    categorySubscriptions?: Array<string>;
}

export function UserMeFromJSON(json: any): UserMe {
    return {
        'userId': json['userId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isMod': !exists(json, 'isMod') ? undefined : json['isMod'],
        'created': new Date(json['created']),
        'pic': !exists(json, 'pic') ? undefined : json['pic'],
        'picUrl': !exists(json, 'picUrl') ? undefined : json['picUrl'],
        'isExternal': !exists(json, 'isExternal') ? undefined : json['isExternal'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'emailVerified': !exists(json, 'emailVerified') ? undefined : json['emailVerified'],
        'emailNotify': json['emailNotify'],
        'iosPush': json['iosPush'],
        'androidPush': json['androidPush'],
        'browserPush': json['browserPush'],
        'hasPassword': json['hasPassword'],
        'intercomIdentity': !exists(json, 'intercomIdentity') ? undefined : json['intercomIdentity'],
        'categorySubscriptions': !exists(json, 'categorySubscriptions') ? undefined : json['categorySubscriptions'],
    };
}

export function UserMeToJSON(value?: UserMe): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'userId': value.userId,
        'name': value.name,
        'isMod': value.isMod,
        'created': value.created.toISOString(),
        'pic': value.pic,
        'picUrl': value.picUrl,
        'isExternal': value.isExternal,
        'email': value.email,
        'emailVerified': value.emailVerified,
        'emailNotify': value.emailNotify,
        'iosPush': value.iosPush,
        'androidPush': value.androidPush,
        'browserPush': value.browserPush,
        'hasPassword': value.hasPassword,
        'intercomIdentity': value.intercomIdentity,
        'categorySubscriptions': value.categorySubscriptions,
    };
}


